import React from 'react'
import { formatCurrency, formatNumber } from '../../../lib/utils/formatNumber'
import { DisplayCreative } from '../../../lib/types/DisplayCreativeMetrics'
import HoverMedia from '../../HoverMedia'
import { useGetDealershipConversionGoalsByDealershipID } from '../../../api/dealership/audiences/useGetConversionGoalsByDealershipID'
import { useDealership } from '../../../store/zustand/dealershipStore'
import { useParams } from 'react-router'
import { useGetAgencyByAgencyId } from '../../../api/agencies/useGetAgencyByAgencyId'

const GridItemCreative = ({ item }: { item: DisplayCreative }): JSX.Element => {
  const dealership = useDealership()
  const { data: tag_names } = useGetDealershipConversionGoalsByDealershipID()
  const { agency_id } = useParams()

  const { data: agency } = useGetAgencyByAgencyId(agency_id)

  return (
    <div className={'rounded-lg h-full'}>
      <div
        className={
          'flex h-[220px] justify-center items-center border-t-2 border-x-2 rounded-lg'
        }>
        <div className="w-fit items-center self-center">
          {item.image_url?.endsWith('.mov') || item.image_url?.endsWith('.mp4') ? (
            <HoverMedia
              src={item.image_url}
              type={'video'}
              scale={false}
              className="rounded-xl w-fit h-fit object-cover object-scale-down max-h-[220px]"
            />
          ) : item.image_url?.endsWith('.jpg') ||
            item.image_url?.endsWith('.jpeg') ||
            item.image_url?.endsWith('.png') ||
            item.image_url?.endsWith('.gif') ||
            item.image_url?.includes(
              'client-creative-images.s3.amazonaws.com/facebook',
            ) ? (
            <img
              className={`rounded-xl w-fit h-fit object-cover object-scale-down max-h-[220px]`}
              src={item.image_url}
            />
          ) : (
            <></>
          )}
        </div>
      </div>
      <div
        className={
          'flex flex-col gap-3 bg-cultured-gray text-primary-xiketic p-5 border-2 h-fit py-3'
        }>
        <div className="flex flex-col gap-1">
          <span className={'text-base font-bold'}>{item.creative_name}</span>
          {item.creative_body && (
            <span className="text-base text-xs font-bold">{item.creative_body}</span>
          )}
        </div>
        <span className={'flex flex-col font-medium text-xs gap-1'}>
          Size: {item.creative_size}
        </span>
        <div className="grid grid-cols-2">
          <div className="flex flex-col font-medium text-xs gap-1">
            <span className="font-bold pt-2">Metrics</span>
            <span>Impressions: {formatNumber(item.impressions ?? 0)}</span>
            <span>Clicks: {formatNumber(item.clicks ?? 0)}</span>
            <span>Views: {formatNumber(item.views ?? 0)}</span>
            {agency?.show_budget_type > 0 && (
              <span>
                $/Click:{' '}
                {formatCurrency(
                  item.clicks > 0
                    ? (Math.max(Number(item.client_spend), Number(item.actual_spend)) ??
                        0) / item.clicks
                    : 0,
                )}
              </span>
            )}
          </div>
          {dealership?.attribution_tracking?.goals &&
            dealership?.attribution_tracking?.goals?.length > 0 && (
              <div className="flex flex-col font-medium text-xs gap-1">
                <span className="font-bold pt-2">Conversions</span>
                {tag_names?.map((d) => {
                  return (
                    <span key={d.id}>
                      {d.tag_name}: {formatNumber(item[d.tag_name] ?? 0)}
                    </span>
                  )
                })}
                {agency?.show_budget_type > 0 && (
                  <span>
                    CPA:{' '}
                    {formatCurrency(
                      tag_names &&
                        tag_names?.reduce(
                          (acc, cur) => acc + Number(item[cur.tag_name]),
                          0,
                        ) > 0
                        ? (Math.max(
                            Number(item.client_spend),
                            Number(item.actual_spend),
                          ) ?? 0) /
                            tag_names?.reduce(
                              (acc, cur) => acc + Number(item[cur.tag_name]),
                              0,
                            )
                        : 0,
                    )}
                  </span>
                )}
              </div>
            )}
        </div>
        <div>
          <a
            href={item?.image_url}
            target={'_blank'}
            className={'text-primary-persian-blue font-bold text-sm'}
            rel="noreferrer">
            View on source
          </a>
        </div>
      </div>
    </div>
  )
}

export default GridItemCreative
